import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { TweenMax, TimelineMax, CSSPlugin, Expo } from 'gsap/all';
import DrawSVGPlugin from '../gsap-bonus/DrawSVGPlugin';


import Video from './Video';



import '../styles/components/hero.scss';


import logo from '../assets/logo.svg';
import hero from '../assets/hero.png';
import play from '../assets/play-button.svg';
import cross from '../assets/cross.svg';



const plugins = [ CSSPlugin ];


export default class Hero extends Component {

    state = {
      open: false,
      play: false
    }

    constructor(props) {
      super(props);
      this.strokes = [];
      this.hero = null;
      this.introMessage = null;
      this.playBtn = null;
    }

    toggleVideoOn = () => {
      this.setState({
        open: !this.state.open,
        play: !this.state.play
      })
    }

    toggleVideoOff = () => {
      this.setState({
        open: !this.state.open,
        play: !this.state.play
      })
    }

    componentDidMount() {

      TweenMax.set(this.strokes, {
        drawSVG: 0,
        visibility: 'visible'
      })
      TweenMax.set(this.hero, {
        opacity: 0
      })
      TweenMax.set(this.introMessage, {
        opacity: 0,
        y: '-20px'
      })
      TweenMax.set(this.playBtn, {
        opacity: 0,
        y: '20px',
        visibility: 'visible'
      })

      const strokeTl = new TimelineMax({paused: true});

      strokeTl.to(this.strokes, 2.5, {
        drawSVG: '100%',
        ease: Expo.easeInOut
      })
      .to(this.hero, 0.5, {
        opacity: 1
      }, '-=0.25')
      .to(this.strokes, 0.5, {
        opacity: 0
      }, '-=0.5')
      .to(this.introMessage, 1, {
        opacity: 1,
        y: 0
      }, '-=0.5')
      .to(this.playBtn, 1, {
        opacity: 1,
        y: 0
      })
      .play();
    }

    render() {

        return (
          <div className="hero">
            <div ref={div => this.introMessage = div} className="g-message">
              <span>VIRTUAL REALITY</span>
              <img src={ logo } alt='vive logo' className="large" />
              <span className="immerse">Explore new realities, redefine your expectations of immersion in <br />gaming with moments so intense your intuition takes over.</span>
            </div>
            <div className="image-group">
              <img ref={img => this.hero = img} src={ hero } alt='vive front image' />
              <svg viewBox="0 0 735.34 715.45">
                <path ref={(stroke) => { this.strokes.push(stroke) }}d="M306.36,88.64c-4.1,6.13-23.11,31.87-60.82,45.59-4.35,2.17-49.52,20.85-78.63,52.12S123,253.25,123,253.25s-17.57,38.22-23.63,52.09a22.16,22.16,0,0,1-6.33,8.33,261.17,261.17,0,0,1-29.94,21.12,31,31,0,0,0-5.84,4.61C49.16,347.63,28,372.54,23.13,443.94c-.2,4.57-.21,10.94-.17,16.52a200.27,200.27,0,0,0,1.17,20.19c1.08,10.1,2.43,27.85.51,42.1a147.79,147.79,0,0,0-1.39,25.83c1.35,34.16,8.64,100.07,48,126.56,1.09.74,2.17,1.48,3.21,2.29,8.94,7,34.78,24,66.83,29.32,27.64,4.61,46.32,8.92,57.93,11.54A73.74,73.74,0,0,0,212,720c29.18,1.37,150.44,8.22,174.11,6.47,1.39-.1,2.78-.16,4.18-.15,26.83.17,174.51-3,198.38-10.21a75.1,75.1,0,0,1,10.4-2.31c22.2-3.4,70-11.27,87.24-25.35a69,69,0,0,1,9.11-6.21c17.54-10.18,46.77-30.85,54.42-99.74,2.73-21.84,3.75-38.53,4.12-47.92a54.23,54.23,0,0,0-1-12.84c-1.08-5.42-2.07-16.53.74-36.32a52.22,52.22,0,0,0,.53-7c.31-34.43-1.43-112.93-38.27-141.82-2.17-1.3-36.49-23.89-36.92-26.5s-40.84-99-71.24-124.67c-30.21-25.45-42-35.91-90.25-56.49a10.6,10.6,0,0,1-1.84-1c-25.45-17.61-25.86-16.24-45.88-37.37a5.21,5.21,0,0,1-1.44-3.6c.06-14.29-2.69-32.74-3.63-38.63a2.25,2.25,0,0,0-2.23-1.9H462a4,4,0,0,1-2.49-.87c-3.77-3-18.4-13.49-50.66-23-.44-2.61-.11-7.28-7.28-7.28s-6.19,4.56-6.19,4.56-.45-4.56-6.79-4.56c-3.49,0-5,1.38-5.71,2.62a.8.8,0,0,1-1.38.09A6.32,6.32,0,0,0,376,15.31c-5.43,0-8,1.85-7.6,6.63-4.34,1-42.24,9.12-58.32,28.88-1.08,3.7-2,5-1.73,9.56.19,4.15-1.23,20-1.16,25.61A4.54,4.54,0,0,1,306.36,88.64Z" transform="translate(-20.94 -13.31)"/>
                <path ref={(stroke) => { this.strokes.push(stroke) }} d="M183.85,290.82s-2.82-42.13,45.62-64.94,74.28-25.41,74.28-25.41l-1.49,79.79a1.71,1.71,0,0,1-1.9,1.67l-.72-.08a1.71,1.71,0,0,1-1.5-1.47l-.05-.4a1.71,1.71,0,0,0-1.75-1.48c-11.85.44-87.85,3.37-91.85,5.37C200.14,286,183.85,290.82,183.85,290.82Z" transform="translate(-20.94 -13.31)"/>
                <path ref={(stroke) => { this.strokes.push(stroke) }} d="M472.72,200.25,474,280.44a1.51,1.51,0,0,0,1.5,1.48h1.15a1.5,1.5,0,0,0,1.5-1.5h0a1.5,1.5,0,0,1,1.54-1.51c10.81.27,75.69,1.92,91.2,4.31,16.73,4.56,19.34,8,20.2,8s-1.63-43.43-34.89-59a46.41,46.41,0,0,1-4.94-2.71C543,224.36,521.67,211.74,472.72,200.25Z" transform="translate(-20.94 -13.31)"/>
                <path ref={(stroke) => { this.strokes.push(stroke) }} d="M351.17,224.35l-14.63,25.86v4.56l10.1,12.7s3.54-37.2,4.71-43.06A.1.1,0,0,0,351.17,224.35Z" transform="translate(-20.94 -13.31)"/>
                <path ref={(stroke) => { this.strokes.push(stroke) }} d="M369.57,207.69l-7.9,60.79a.26.26,0,0,0,.26.3h7.9a.27.27,0,0,0,.27-.27V207.72A.27.27,0,0,0,369.57,207.69Z" transform="translate(-20.94 -13.31)"/>
                <path ref={(stroke) => { this.strokes.push(stroke) }} d="M408.87,268.78h16.61s-13-20.2-16.61-30.95Z" transform="translate(-20.94 -13.31)"/>
                <path ref={(stroke) => { this.strokes.push(stroke) }} d="M410.53,202c1.77,8.42,10,44.42,23.42,59.9,2.79-3.88,4.45-6.32,5.44-7.82a4.21,4.21,0,0,0,.1-4.48L411.1,201.82A.31.31,0,0,0,410.53,202Z" transform="translate(-20.94 -13.31)"/>
              </svg>
            </div>
            <div className="play-group" ref={div => this.playBtn = div}>
              <div className="play" onClick={this.toggleVideoOn}>
                <img src={ play } alt='play icon' />
              </div>
              <span>SEE IT IN ACTION</span>
            </div>
            <Video
              openState={ this.state.open }
              closeState={ this.toggleVideoOff }
              playState={ this.state.play }
              videoUrl="https://vimeo.com/157425771"
            />
          </div>
        );
    }
}
